const types = {
  SET_OVERLAY: 'SET_OVERLAY',
  SET_ACTIVE_ACCOUNT: 'SET_ACTIVE_ACCOUNT',
  SWITCH_ACCOUNT: 'SWITCH_ACCOUNT',
  SWITCHED_ACCOUNT: 'SWITCHED_ACCOUNT',
  SET_IS_ADMIN: 'SET_IS_ADMIN',
  SET_NAV_REF: 'SET_NAV_REF',
  SET_MENU_REF: 'SET_MENU_REF',
  SET_NAV_TOGGLE_REF: 'SET_NAV_TOGGLE_REF',
  SET_MENU_TOGGLE_REF: 'SET_MENU_TOGGLE_REF',
  SET_PUSH_NOTIFICATION: 'SET_PUSH_NOTIFICATION'
};

export default types;
